export interface Article {
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  tag: string;
  excerpt: string;
  date: string;
  views: number;
  likes: number;
  cover: string;
  author: string;
  duration: string;
  hot?: boolean;
  related?: string[];
}

export const articles: Article[] = [
  {
    slug: "shengyu-yufeng-lindong-gongbao",
    title: "《圣域·御风》新版本联动公报告捷，漫画化企划正式公开",
    category: "联动情报",
    categorySlug: "liandong-qingbao",
    tag: "联动情报",
    excerpt:
      "人气开放世界手游《圣域·御风》与知名漫画IP达成深度联动，官方同步公开联动主题漫画的第一话内容，玩家可在活动期间解锁专属联动角色与剧情篇章。",
    date: "2026-08-15",
    views: 28642,
    likes: 2310,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20game%20crossover%20comic%20illustration%20with%20a%20warrior%20girl%20and%20golden%20dragon%2C%20vibrant%20ink%20painting%20style%2C%20warm%20orange%20and%20gold%20palette%2C%20dynamic%20action%20pose%2C%20manga%20panel%20composition%2C%20rich%20detail%2C%20soft%20lighting&width=1200&height=800&seq=keyou-art-01&orientation=landscape",
    author: "可游编辑·青黛",
    duration: "6分钟",
    hot: true,
    related: ["xinyou-manhuahu-shi-xian", "gongjue-zhoumian-huodong"],
  },
  {
    slug: "xinyou-manhuahu-shi-xian",
    title: "新游漫画化《时弦之境》首话上线：从游戏到漫画的完美跨越",
    category: "新游漫画化",
    categorySlug: "xinyou-manhuahu",
    tag: "漫画化",
    excerpt:
      "回合制策略新作《时弦之境》官方改编漫画正式连载，首话以游戏序章剧情为蓝本，补全了更多世界观细节与角色前史，为玩家带来全新的叙事体验。",
    date: "2026-08-12",
    views: 19204,
    likes: 1745,
    cover: "https://readdy.ai/api/search-image?query=manga%20style%20illustration%20of%20a%20strategic%20rpg%20hero%20holding%20a%20magical%20hourglass%2C%20fantasy%20world%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20dynamic%20speed%20lines%2C%20comic%20art%20style%2C%20clean%20background&width=1200&height=800&seq=keyou-art-02&orientation=landscape",
    author: "可游编辑·折木",
    duration: "5分钟",
    related: ["shengyu-yufeng-lindong-gongbao", "banben-3-0-da-kaibu"],
  },
  {
    slug: "banben-3-0-da-kaibu",
    title: "《幻想编年史》3.0大版本更新：全新活动漫画与主线剧情同步上线",
    category: "版本更新",
    categorySlug: "banben-gengxin",
    tag: "版本更新",
    excerpt:
      "《幻想编年史》迎来3.0大型版本更新，除全新地图与玩法外，官方还特别制作了与版本同步的活动漫画，将新BOSS的起源故事以漫画形式完整呈现。",
    date: "2026-08-09",
    views: 15783,
    likes: 1320,
    cover: "https://readdy.ai/api/search-image?query=fantasy%20rpg%20game%20update%20banner%20illustration%20with%20epic%20boss%20creature%20and%20adventurers%2C%20comic%20book%20style%20artwork%2C%20warm%20gold%20and%20deep%20green%20tones%2C%20dramatic%20lighting%2C%20dynamic%20composition&width=1200&height=800&seq=keyou-art-03&orientation=landscape",
    author: "可游编辑·时雨",
    duration: "7分钟",
    hot: true,
    related: ["shouye-shuangban-gonglue", "xinyou-manhuahu-shi-xian"],
  },
  {
    slug: "gongjue-zhoumian-huodong",
    title: "《星轨共鸣》两周年庆典：限定联动漫画与海量福利活动一览",
    category: "游戏资讯",
    categorySlug: "youxi-zixun",
    tag: "游戏资讯",
    excerpt:
      "太空题材卡牌游戏《星轨共鸣》迎来两周年庆典，官方推出限定联动漫画、纪念角色和丰富的签到福利，活动详情与时间安排全面汇总。",
    date: "2026-08-06",
    views: 22531,
    likes: 1890,
    cover: "https://readdy.ai/api/search-image?query=space%20themed%20card%20game%20anniversary%20celebration%20illustration%20with%20astronaut%20and%20planets%2C%20comic%20art%20style%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20festive%20banners%2C%20clean%20composition&width=1200&height=800&seq=keyou-art-04&orientation=landscape",
    author: "可游编辑·青黛",
    duration: "4分钟",
    hot: true,
    related: ["shengyu-yufeng-lindong-gongbao", "gongjue-zhoumian-huodong"],
  },
  {
    slug: "shouye-shuangban-gonglue",
    title: "《猎影行动》双版本更新对比：武器平衡调整与活动漫画解析",
    category: "版本更新",
    categorySlug: "banben-gengxin",
    tag: "版本更新",
    excerpt:
      "战术射击游戏《猎影行动》发布双版本更新，本文详细对比武器平衡调整、地图改动，并解析同步上线的版本活动漫画中的隐藏彩蛋。",
    date: "2026-08-03",
    views: 11847,
    likes: 980,
    cover: "https://readdy.ai/api/search-image?query=tactical%20shooter%20game%20soldier%20illustration%20with%20weapons%20and%20urban%20background%2C%20modern%20comic%20style%2C%20warm%20orange%20and%20dark%20green%20tones%2C%20action%20pose%2C%20dynamic%20angle&width=1200&height=800&seq=keyou-art-05&orientation=landscape",
    author: "可游编辑·折木",
    duration: "6分钟",
  },
  {
    slug: "dongsai-zhanji-hezuo",
    title: "热血格斗《东煞战记》×美食动画联动：别样的热血美食漫画",
    category: "联动情报",
    categorySlug: "liandong-qingbao",
    tag: "联动情报",
    excerpt:
      "热血格斗游戏《东煞战记》宣布与知名美食动画联动，推出独特的料理对决玩法，并同步连载联动主题漫画，将格斗与美食创意结合。",
    date: "2026-07-30",
    views: 13679,
    likes: 1210,
    cover: "https://readdy.ai/api/search-image?query=fighting%20game%20character%20and%20delicious%20food%20crossover%20comic%20illustration%2C%20energetic%20manga%20style%2C%20warm%20orange%20and%20gold%20colors%2C%20dynamic%20cooking%20battle%20scene%2C%20clean%20background&width=1200&height=800&seq=keyou-art-06&orientation=landscape",
    author: "可游编辑·时雨",
    duration: "5分钟",
    related: ["shengyu-yufeng-lindong-gongbao", "gongjue-zhoumian-huodong"],
  },
  {
    slug: "mofashi-xueyuan-shouhua",
    title: "魔法学院题材《咒纹学院》漫画化企划公布，首张视觉图释出",
    category: "新游漫画化",
    categorySlug: "xinyou-manhuahu",
    tag: "漫画化",
    excerpt:
      "魔法学院题材游戏《咒纹学院》正式公布漫画化企划，首张视觉图与制作团队阵容同步公开，改编漫画预计于新版本上线时同步开启连载。",
    date: "2026-07-27",
    views: 8923,
    likes: 764,
    cover: "https://readdy.ai/api/search-image?query=magic%20academy%20game%20illustration%20with%20young%20mage%20students%20and%20glowing%20spell%20runes%2C%20manga%20style%2C%20warm%20gold%20and%20teal%20palette%2C%20whimsical%20and%20detailed&width=1200&height=800&seq=keyou-art-07&orientation=landscape",
    author: "可游编辑·青黛",
    duration: "4分钟",
  },
  {
    slug: "jingling-qiyuan-daigeng",
    title: "《精灵祈愿》大型活动上线：联动漫画每日连载，剧情福利双丰收",
    category: "游戏资讯",
    categorySlug: "youxi-zixun",
    tag: "游戏资讯",
    excerpt:
      "治愈系放置游戏《精灵祈愿》开启大型主题活动，官方联动漫画进入每日连载模式，玩家通过活动任务即可解锁漫画剧情与专属奖励。",
    date: "2026-07-24",
    views: 10492,
    likes: 856,
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20idle%20game%20spirit%20creatures%20illustration%2C%20soft%20manga%20style%2C%20warm%20orange%20and%20gold%20tones%2C%20adorable%20characters%2C%20clean%20bright%20background&width=1200&height=800&seq=keyou-art-08&orientation=landscape",
    author: "可游编辑·折木",
    duration: "5分钟",
  },
  {
    slug: "yaojiang-hunwu-qixuan",
    title: "《妖界幻物》全新活动漫画：隐藏角色剧情与通关技巧解析",
    category: "游戏资讯",
    categorySlug: "youxi-zixun",
    tag: "游戏资讯",
    excerpt:
      "《妖界幻物》本周上线全新活动漫画，官方在漫画中埋下了隐藏角色剧情的线索。本文梳理剧情脉络，并提供实用的活动通关技巧与奖励速刷建议。",
    date: "2026-07-20",
    views: 8421,
    likes: 690,
    cover: "https://readdy.ai/api/search-image?query=mythical%20beast%20collection%20game%20illustration%20with%20spirit%20fox%20and%20crystal%20forest%2C%20manga%20style%2C%20warm%20orange%20and%20gold%20tones%2C%20magical%20atmosphere%2C%20clean%20background&width=1200&height=800&seq=keyou-art-09&orientation=landscape",
    author: "可游编辑·时雨",
    duration: "6分钟",
  },
  {
    slug: "dongman-daomei-liandong",
    title: "《机甲战线》与机甲动画《铁臂泰坦》联动预告：漫画先行",
    category: "联动情报",
    categorySlug: "liandong-qingbao",
    tag: "联动情报",
    excerpt:
      "动作机甲游戏《机甲战线》宣布与经典机甲动画《铁臂泰坦》联动，联动漫画将先行连载，为玩家提前铺陈两个世界观的碰撞剧情。",
    date: "2026-07-17",
    views: 11905,
    likes: 1102,
    cover: "https://readdy.ai/api/search-image?query=mecha%20robot%20game%20crossover%20comic%20illustration%20with%20giant%20robot%20and%20pilot%2C%20energetic%20manga%20style%2C%20warm%20orange%20and%20dark%20green%2C%20dynamic%20action%2C%20clean%20background&width=1200&height=800&seq=keyou-art-10&orientation=landscape",
    author: "可游编辑·青黛",
    duration: "5分钟",
    related: ["shengyu-yufeng-lindong-gongbao", "dongsai-zhanji-hezuo"],
  },
  {
    slug: "wuxia-xianjian-gai",
    title: "《问道仙途》漫画化官宣：从端游到漫画的经典延续",
    category: "新游漫画化",
    categorySlug: "xinyou-manhuahu",
    tag: "漫画化",
    excerpt:
      "经典仙侠端游《问道仙途》宣布漫画化，改编漫画将聚焦游戏初代主角的成长线，还原原作剧情精髓的同时加入全新支线，情怀与新鲜感兼备。",
    date: "2026-07-14",
    views: 9877,
    likes: 903,
    cover: "https://readdy.ai/api/search-image?query=chinese%20xianxia%20cultivation%20game%20comic%20illustration%20with%20sword%20immortal%20character%2C%20ink%20wash%20and%20manga%20style%2C%20warm%20orange%20and%20teal%20palette%2C%20elegant%20and%20dynamic&width=1200&height=800&seq=keyou-art-11&orientation=landscape",
    author: "可游编辑·折木",
    duration: "5分钟",
    related: ["xinyou-manhuahu-shi-xian", "mofashi-xueyuan-shouhua"],
  },
  {
    slug: "banben-2-5-zhanting",
    title: "《裂空传说》2.5版本预告：版本更新漫画揭示新大陆真相",
    category: "版本更新",
    categorySlug: "banben-gengxin",
    tag: "版本更新",
    excerpt:
      "《裂空传说》放出2.5版本预告，同步公开版本更新漫画，用漫画叙事揭示新大陆的真相与隐藏BOSS的来历，为版本上线做足了铺垫。",
    date: "2026-07-11",
    views: 7236,
    likes: 604,
    cover: "https://readdy.ai/api/search-image?query=fantasy%20adventure%20game%20update%20comic%20illustration%20with%20new%20continent%20map%20and%20dragon%20boss%2C%20manga%20style%2C%20warm%20gold%20and%20deep%20green%2C%20epic%20scale%2C%20clean%20background&width=1200&height=800&seq=keyou-art-12&orientation=landscape",
    author: "可游编辑·时雨",
    duration: "6分钟",
    related: ["banben-3-0-da-kaibu", "shouye-shuangban-gonglue"],
  },
];

export const featuredArticles = articles.filter((a) => a.hot);

export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export const getArticle = (slug: string) => articles.find((a) => a.slug === slug);

export const getArticlesByCategory = (slug: string) =>
  articles.filter((a) => a.categorySlug === slug);

export const getRelatedArticles = (article: Article) => {
  const related = (article.related || [])
    .map((slug) => articles.find((a) => a.slug === slug))
    .filter((a): a is Article => Boolean(a));
  if (related.length >= 3) return related;
  const sameCat = articles.filter(
    (a) => a.categorySlug === article.categorySlug && a.slug !== article.slug && !related.includes(a)
  );
  const fill = [...related, ...sameCat].filter((a, i, arr) => arr.indexOf(a) === i);
  return fill.slice(0, 3);
};